import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "measurement-list-item"
}
const _hoisted_2 = { class: "measurement-list-item__section measurement-list-item__section--saddle" }
const _hoisted_3 = { class: "measurement-list-item__row" }
const _hoisted_4 = { class: "measurement-list-item__column-header" }
const _hoisted_5 = { class: "measurement-list-item__row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "measurement-list-item__row" }
const _hoisted_9 = { class: "measurement-list-item__difference" }
const _hoisted_10 = { class: "measurement-list-item__row" }
const _hoisted_11 = { class: "measurement-list-item__difference" }
const _hoisted_12 = { class: "measurement-list-item__section measurement-list-item__section--handlebar" }
const _hoisted_13 = { class: "measurement-list-item__row" }
const _hoisted_14 = { class: "measurement-list-item__column-header" }
const _hoisted_15 = { class: "measurement-list-item__row" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "measurement-list-item__row" }
const _hoisted_19 = { class: "measurement-list-item__difference" }
const _hoisted_20 = { class: "measurement-list-item__row" }
const _hoisted_21 = { class: "measurement-list-item__difference" }
const _hoisted_22 = { class: "measurement-list-item__section measurement-list-item__section--crankset" }
const _hoisted_23 = { class: "measurement-list-item__row" }
const _hoisted_24 = { class: "measurement-list-item__column-header" }
const _hoisted_25 = { class: "measurement-list-item__row" }
const _hoisted_26 = {
  key: 0,
  class: "measurement-list-item__height"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "measurement-list-item__section measurement-list-item__section--pedals" }
const _hoisted_29 = { class: "measurement-list-item__row" }
const _hoisted_30 = { class: "measurement-list-item__column-header" }
const _hoisted_31 = { class: "measurement-list-item__row" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "measurement-list-item__row" }
const _hoisted_35 = {
  key: 0,
  class: "measurement-list-item__height"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "measurement-list-item__actions" }

import { useMeasurementStore } from '@/store/measurementStore'
import { storeToRefs } from 'pinia'
import {
  IconButtonType,
  ButtonState,
  BfIconButton,
} from '@finetic/bikefitting-ui'
import { measurementType } from '@/types/measurement'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementListItem',
  props: {
    index: { default: 0 },
    measurement: { default: undefined }
  },
  setup(__props: any) {

const { t } = useI18n()
const measurementStore = useMeasurementStore()
const { firstMeasurement } = storeToRefs(measurementStore)



const deleteMeasurement = (index: number) => {
  measurementStore.delete(index)
}

return (_ctx: any,_cache: any) => {
  return (__props.measurement)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('common.bike.saddle')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("strong", null, [
              (__props.measurement.saddle.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.measurement.saddle.active.SADDLE_BRAND) + " " + _toDisplayString(__props.measurement.saddle.active.SADDLE_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.x')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${__props.measurement.saddle.x} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_9, "(" + _toDisplayString(`${__props.measurement.saddle.x - _unref(firstMeasurement).saddle.x} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.y')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${__props.measurement.saddle.y} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(`${__props.measurement.saddle.y - _unref(firstMeasurement).saddle.y} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('common.bike.handlebar')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("strong", null, [
              (__props.measurement.handlebar.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(__props.measurement.handlebar.active.HANDLEBAR_BRAND) + " " + _toDisplayString(__props.measurement.handlebar.active.HANDLEBAR_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.x')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${__props.measurement.handlebar.x * -1} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(`${(__props.measurement.handlebar.x - _unref(firstMeasurement).handlebar.x) * -1} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.y')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${__props.measurement.handlebar.y} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_21, "(" + _toDisplayString(`${__props.measurement.handlebar.y - _unref(firstMeasurement).handlebar.y} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('common.bike.crankset')), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "measurement-list-item__row" }, [
            _createElementVNode("strong", null, [
              _createElementVNode("span", null, "-")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            (__props.measurement.crankset.active)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(`${__props.measurement.crankset.active} ${_unref(t)('common.unit.mm')}`), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('common.bike.pedals')), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("strong", null, [
              (__props.measurement.pedal.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(__props.measurement.pedal.active.PEDAL_BRAND) + " " + _toDisplayString(__props.measurement.pedal.active.PEDAL_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            (__props.measurement.pedal.active)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(`${__props.measurement.pedal.active.PEDAL_HEIGHT} ${_unref(t)('common.unit.mm')}`), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_unref(BfIconButton), {
            state: __props.index !== 0 ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled,
            type: _unref(IconButtonType).Circular,
            icon: "/icons/01-Interface Essential/23-Delete/bin-1.svg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteMeasurement(__props.index)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.delete')), 1)
            ]),
            _: 1
          }, 8, ["state", "type"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})